<div class="container pt-3 fade-in-left" id="centerFrame">
    <div class="d-flex align-items-center justify-content-center mb-4 pe-2">
        <a (click)="back()"><div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div></a>
        @if(id_perfil() === 1 || id_perfil() === 2){
            <div class="p-2 ms-1" [routerLink]="['/my-account-identidad']" >
                <img [src]="preview_img_avatar() == '' ? './assets/img/user-init.png' : preview_img_avatar()" class="title-image-user rounded-circle business-profile">
            </div>
        }
        @if(id_perfil() === 3){
            <div class="p-2 ms-1" [routerLink]="['/my-account-identidad-prestador']">
                <img [src]="preview_img_avatar() == '' ? './assets/img/user-init.png' : preview_img_avatar()" class="title-image-user rounded-circle business-profile">
            </div>
        }
        @if(id_perfil() === 4){
            <div class="p-2 ms-1" [routerLink]="['/my-account-identidad-comercio']">
                <img [src]="preview_img_avatar() == '' ? './assets/img/user-init.png' : preview_img_avatar()" class="title-image-user rounded-circle business-profile">
            </div>
        }
        <div class="p-2 ms-1 flex-grow-1">
            <div class="title-name">{{nombre()}}</div>
            <div class="title-mail">{{email()}}</div>
        </div>
    </div>

    <!-- Sections -->
    <div class="row-cols-12 m-2">
        <!-- <div class="text-p p-3">
            Mantené actualizados los datos de tu cuenta siempre
        </div> -->
        <a [routerLink]="['/my-account-email']"><div class="row p-3 align-items-center">
            <div class="col-auto"><i class="bi bi-envelope"></i></div>
            <div class="col">
                <div class="col-10 text-title-item">E-mail</div>
                <div class="col-10 text-detail-item">{{email()}}</div>
            </div><div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div>
        </div></a>
        <a [routerLink]="['/my-account-password']">
            <div class="row p-3 align-items-center">
                <div class="col-auto"><i class="bi bi-lock"></i></div>
                <div class="col">
                    <div class="col-10 text-title-item">Contraseña</div>
                    <div class="col-10 text-detail-item">Cambiar</div>
                </div>
                <div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div>
            </div>
        </a>
        @if(id_perfil() === 1 || id_perfil() === 2){
            <a [routerLink]="['/my-account-identidad']">
                <div class="row p-3 align-items-center">
                    <div class="col-auto"><i class="bi bi-card-heading"></i></div>
                    <div class="col">
                        <div class="col-10 text-title-item">Identidad</div>
                        <div class="col-10 text-detail-item">Tus datos personales</div>
                    </div>
                    <div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div>
                </div>
            </a>
        }
        @if(id_perfil() === 2){
            <a [routerLink]="['/my-account-obra-social']">
                <div class="row p-3 align-items-center">
                    <div class="col-auto"><i class="bi bi-clipboard2-pulse"></i></div>
                    <div class="col">
                        <div class="col-10 text-title-item">Obra Social / Prepaga</div>
                        <div class="col-10 text-detail-item">Tus datos de cobertura</div>
                    </div>
                    <div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div>
                </div>
            </a>
        }
        @if(id_perfil() === 4){
            <a [routerLink]="['/my-account-identidad-comercio']">
                <div class="row p-3 align-items-center">
                    <div class="col-auto"><i class="bi bi-card-heading"></i></div>
                    <div class="col">
                        <div class="col-10 text-title-item">Comercio</div>
                        <div class="col-10 text-detail-item">Tus datos comerciales</div>
                    </div>
                    <div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div>
                </div>
            </a>
        }
        @if(id_perfil() === 3){
            <a [routerLink]="['/my-account-identidad-prestador']">
                <div class="row p-3 align-items-center">
                    <div class="col-auto"><i class="bi bi-card-heading"></i></div>
                    <div class="col">
                        <div class="col-10 text-title-item">Prestador</div>
                        <div class="col-10 text-detail-item">Tus datos personales</div>
                    </div>
                    <div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div>
                </div>
            </a>
        }
        @if(id_perfil() !== 1){
            <a [routerLink]="['/my-account-ubicaciones']">
                <div class="row p-3 align-items-center">
                    <div class="col-auto"><i class="bi bi-geo-alt"></i></div>
                    <div class="col">
                        <div class="col-10 text-title-item">{{(id_perfil() == 3 || id_perfil() == 4) ? 'Ubicaciones' : 'Direcciones' }}</div>
                        <div class="col-10 text-detail-item">Tus {{(id_perfil() == 3 || id_perfil() == 4) ? 'ubicaciones' : 'direcciones' }} guardadas en tu cuenta</div>
                    </div>
                    <div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div>
                </div>
            </a>
        }
        @if(id_perfil() === 4){
            <a [routerLink]="['/my-account-horarios']">
                <div class="row p-3 align-items-center">
                    <div class="col-auto"><i class="bi bi-clock"></i></div>
                    <div class="col">
                        <div class="col-10 text-title-item">Horarios</div>
                        <div class="col-10 text-detail-item">Tus horarios</div>
                    </div>
                    <div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div>
                </div>
            </a>
            <a [routerLink]="['/my-account-productos']">
                <div class="row p-3 align-items-center">
                    <div class="col-auto"><i class="bi bi-box-seam"></i></div>
                    <div class="col">
                        <div class="col-10 text-title-item">Productos</div>
                        <div class="col-10 text-detail-item">Tus productos</div>
                    </div>
                    <div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div>
                </div>
            </a>
        }
        @if(id_perfil() == 3){
            <a [routerLink]="['/my-account-servicios']">
                <div class="row p-3 align-items-center">
                    <div class="col-auto"><i class="bi bi-briefcase"></i></div>
                    <div class="col">
                        <div class="col-10 text-title-item">Servicios</div>
                        <div class="col-10 text-detail-item">Tus servicios</div>
                    </div>
                    <div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div>
                </div>
            </a>
        }
        @if (id_perfil() === 3 || id_perfil() === 4) {
            <div class="row p-3 align-items-center account-row" (click)="onMercadoPagoClick()">
                <div class="col-auto">
                    <i class="bi" [ngClass]="connect_mercadopago() ? 'bi-check-circle' : 'bi-briefcase'"></i>
                </div>

                <div class="col">
                    <div class="col-10 text-title-item">
                        {{ connect_mercadopago() ? 'Mercado Pago conectado' : 'Conectar con' }}
                        @if (!connect_mercadopago()) {
                            <img class="icon-mercadopago ms-2" src="./assets/img/mercado_pago.png" title="Mercado Pago">
                        }
                    </div>

                    <div class="col-10 text-detail-item">
                        {{ connect_mercadopago()
                            ? 'Tocá para desvincular tu cuenta'
                            : 'Para poder cobrar tus prestaciones en esa cuenta'
                        }}
                    </div>
                </div>

                <div class="col-auto">
                    <div class="form-check form-switch">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            id="connect_mercadopago"
                            [checked]="connect_mercadopago()"
                            readonly
                            (click)="onMercadoPagoClick(); $event.preventDefault(); $event.stopPropagation()"
                        />
                    </div>
                </div>
            </div>
        }
        @if (error()) {
            <div class="alert alert-danger mt-4" role="alert">
                <small>{{ error() }}</small>
            </div>
        }
        @if (message()) {
            <div class="alert alert-success mt-4" role="alert">
                <small>{{ message() }}</small>
            </div>
        }
    </div>
</div>